export default __webpack_public_path__ + "static/media/card-profile4-square.368a64e8.jpg";